<div mat-dialog-title class="text-xl font-medium leading-6">{{ 'user.update-avatar-title' | transloco }}</div>

<mat-dialog-content>
  <div class="flex flex-col items-center gap-4 pt-2">
    <div class="flex h-32 w-32 items-center justify-center overflow-hidden rounded-full border bg-gray-50">
      @if (previewUrl()) {
        <img [src]="previewUrl()" class="h-full w-full object-cover" />
      } @else {
        <mat-icon class="icon-size-16 text-gray-400" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      }
    </div>

    <button mat-stroked-button color="primary" type="button" (click)="fileInput.click()">
      <mat-icon class="mr-2" svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
      {{ 'user.select-file' | transloco }}
    </button>
    <input #fileInput type="file" accept="image/jpeg,image/jpg,image/png,image/gif" hidden (change)="onFileSelected($event)" />

    <span class="text-sm text-secondary">{{ 'user.select-file-hint' | transloco }}</span>

    @if (errorMessage()) {
      <span class="text-sm text-red-500">{{ errorMessage() }}</span>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end gap-2">
  <button mat-raised-button (click)="cancel()">{{ 'button.cancel' | transloco }}</button>
  <button mat-raised-button color="primary" [disabled]="!selectedFile" (click)="confirm()">{{ 'button.update' | transloco }}</button>
</mat-dialog-actions>
